import { UserId, UUID } from 'common/types'

type Authored = { userId: UserId }
type AuthoredText = Authored & { text: string }

/** How many of these entries the given user wrote. */
export const countMine = (
	entries: readonly Authored[] | undefined,
	me: UserId
): number => (entries ?? []).filter(entry => entry.userId === me).length

/** Everything I answered to one open question, oldest first. */
export const myAnswers = (
	entries: readonly AuthoredText[] | undefined,
	me: UserId
): string[] =>
	(entries ?? []).filter(entry => entry.userId === me).map(entry => entry.text)

/**
 * Single choice replaces the selection; multiple choice toggles the option
 * in or out. Order of the previous selection is kept.
 */
export const toggleOption = (
	selected: readonly UUID[],
	option: UUID,
	multiple: boolean
): UUID[] => {
	if (!multiple) {
		return [option]
	}
	return selected.includes(option)
		? selected.filter(id => id !== option)
		: [...selected, option]
}
